import React from "react";

const CoinBasket = ({ basket, onRemove }) => {
  return (
    <div
      className="coin-basket"
      style={{
        marginTop: "20px",
        textAlign: "center",
      }}
    >
      <h3>Your payment</h3>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        {Object.entries(basket).map(([value, count]) =>
          count > 0 ? (
            <li
              key={value}
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: "bold",
                fontSize: "1.2rem",
              }}
            >
              <span>{value}€ x {count}</span>
              <button
                onClick={() => onRemove(parseInt(value))}
                style={{
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginLeft: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                aria-label={`Remove one ${value}€ coin`}
                title={`Remove one ${value}€ coin`}
              >
                −
              </button>
            </li>
          ) : null
        )}
      </ul>
    </div>
  );
};

export default CoinBasket;
